
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCheckboxUncheckGoogle as ObiCheckboxUncheckGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-checkbox-uncheck-google.js';
 
 
 

 
 export const ObiCheckboxUncheckGoogle = createComponent({
   react: React,
   tagName: 'obi-checkbox-uncheck-google',
   elementClass: ObiCheckboxUncheckGoogleElement,
   events: {
     
   }
  });
 
 